import React, {useState} from 'react';
import PageHeader from "../../components/PageHeader";
import DataTable from 'react-data-table-component';
import {customTableStyles} from "../../utils";
import {Link, useNavigate} from "react-router-dom";
import LeadFilter from "./LeadFilter";
import {Button} from "react-bootstrap";
import LeadsSide from './LeadsViewSIde';

const LeadListPage = () => {
    const navigate = useNavigate()
    const [isFilter, setIsFilter] = useState(false)
    const [isView, setIsView] = useState(false)
    const columns = [
        {
            name: 'Name ',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Phone Number',
            selector: row => row.phoneNumber,
            sortable: true,
        },
        {
            name: 'Gender ',
            selector: row => row.gender,
            sortable: true,
        },
        {
            name: 'Assign To',
            selector: row => row.assignTo,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Added By',
            // selector: row => ,
            sortable: true,
            cell: (row) => (
                <span className='badge bg-info'>{row.addedBy}</span>
            ),
        },
        {
            name: 'Updated By',
            // selector: row => row.updatedBy,
            cell: (row) => (
                <span className='badge bg-info'>{row.updatedBy}</span>
            ),
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row, i) => {
                return (
                    <>
                        <div className="hstack gap-1 fs-1">
                            <Button
                                aria-label="anchor"
                                className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                onClick={() => setIsView(true)}
                            >
                                <i className="ri-eye-fill"/>
                            </Button>
                            <a
                                aria-label="anchor"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                onClick={() => navigate('/lead/edit')}
                            >
                                <i className="ri-edit-line"/>
                            </a>
                            <a
                                aria-label="anchor"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-delete-bin-7-line"/>
                            </a>
                        </div>
                    </>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const data = [
        {
            name: 'John Smith',
            email: 'john.smith@example.com',
            phoneNumber: '123-456-7890',
            gender: 'Male',
            assignTo: 'Alice',
            status: 'Active',
            addedBy: 'Admin1',
            updatedBy: 'Admin2',
            createdAt: '2023-01-15',
            updatedAt: '2023-01-20'
        },
        {
            name: 'Alice Johnson',
            email: 'alice.johnson@example.com',
            phoneNumber: '987-654-3210',
            gender: 'Female',
            assignTo: 'Bob',
            status: 'Inactive',
            addedBy: 'Admin2',
            updatedBy: 'Admin1',
            createdAt: '2023-02-10',
            updatedAt: '2023-02-18'
        },
        {
            name: 'Michael Brown',
            email: 'michael.brown@example.com',
            phoneNumber: '111-222-3333',
            gender: 'Male',
            assignTo: 'Charlie',
            status: 'Active',
            addedBy: 'Admin3',
            updatedBy: 'Admin1',
            createdAt: '2023-03-05',
            updatedAt: '2023-03-15'
        },
        {
            name: 'Emily Davis',
            email: 'emily.davis@example.com',
            phoneNumber: '444-555-6666',
            gender: 'Female',
            assignTo: 'David',
            status: 'Active',
            addedBy: 'Admin1',
            updatedBy: 'Admin3',
            createdAt: '2023-04-20',
            updatedAt: '2023-04-25'
        },
        {
            name: 'James Wilson',
            email: 'james.wilson@example.com',
            phoneNumber: '777-888-9999',
            gender: 'Male',
            assignTo: 'Ella',
            status: 'Inactive',
            addedBy: 'Admin2',
            updatedBy: 'Admin3',
            createdAt: '2023-05-10',
            updatedAt: '2023-05-18'
        },
        {
            name: 'Emma Martinez',
            email: 'emma.martinez@example.com',
            phoneNumber: '333-444-5555',
            gender: 'Female',
            assignTo: 'Frank',
            status: 'Active',
            addedBy: 'Admin3',
            updatedBy: 'Admin1',
            createdAt: '2023-06-12',
            updatedAt: '2023-06-20'
        },
        {
            name: 'William Garcia',
            email: 'william.garcia@example.com',
            phoneNumber: '666-777-8888',
            gender: 'Male',
            assignTo: 'Grace',
            status: 'Active',
            addedBy: 'Admin1',
            updatedBy: 'Admin3',
            createdAt: '2023-07-05',
            updatedAt: '2023-07-15'
        },
        {
            name: 'Olivia Rodriguez',
            email: 'olivia.rodriguez@example.com',
            phoneNumber: '222-333-4444',
            gender: 'Female',
            assignTo: 'Harry',
            status: 'Inactive',
            addedBy: 'Admin2',
            updatedBy: 'Admin1',
            createdAt: '2023-08-22',
            updatedAt: '2023-08-28'
        },
        {
            name: 'Liam Martinez',
            email: 'liam.martinez@example.com',
            phoneNumber: '999-000-1111',
            gender: 'Male',
            assignTo: 'Isabella',
            status: 'Active',
            addedBy: 'Admin3',
            updatedBy: 'Admin2',
            createdAt: '2023-09-18',
            updatedAt: '2023-09-25'
        },
        {
            name: 'Sophia Lee',
            email: 'sophia.lee@example.com',
            phoneNumber: '888-999-0000',
            gender: 'Female',
            assignTo: 'Jack',
            status: 'Active',
            addedBy: 'Admin1',
            updatedBy: 'Admin2',
            createdAt: '2023-10-10',
            updatedAt: '2023-10-18'
        }
    ];
    
    return (
        <>
            <PageHeader name="Lead List"/>


            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 ">
                                    <div className="col-auto p-0 d-flex gap-1">
                                        <Link to="/lead/import" className="btn btn-primary">
                                            Import Lead
                                        </Link>
                                        <Link to="/lead/create" className="btn btn-primary">
                                            Create Lead
                                        </Link>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => setIsFilter(true)}
                                        >
                                            <i className="ri-filter-2-fill"/>
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary"
                                        >
                                            <i className="ti-export text-white"/>
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-auto p-0 ms-auto">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line"/>
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <LeadFilter
                show={isFilter}
                close={() => setIsFilter(false)}
            />
            <LeadsSide
                show={isView}
                close={() => setIsView(false)}
            />
        </>
    );
};

export default LeadListPage;